import { render } from "./ReferenceDetail.vue?vue&type=template&id=d869482a"
import script from "./ReferenceDetail.vue?vue&type=script&lang=js"
export * from "./ReferenceDetail.vue?vue&type=script&lang=js"

import "./ReferenceDetail.vue?vue&type=style&index=0&id=d869482a&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__